import ChevronLeft from '@svg/chevron-left.svg';
import ChevronRight from '@svg/chevron-right.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Pagination.module.scss';

function PageButton({ page, label, onClick, disabled, Icon, extraClasses }) {
  return (
    <button
      data-cy="page-button"
      type="button"
      className={classNames(styles.page, extraClasses)}
      onClick={() => onClick(page)}
      disabled={disabled}
    >
      <span className="u-visually-hidden">{label || 'Pagina '}</span>
      {page}
      {Icon && <Icon />}
    </button>
  );
}

function Pagination({
  currentPage,
  hasPrevPage,
  hasNextPage,
  handlePrevPage,
  handleNextPage,
  handleGoToPage,
  loading = false,
  totalPages = null,
}) {
  if ((!hasNextPage && !hasPrevPage && !totalPages) || totalPages === 1)
    return null;

  return (
    <div className={styles.pagination}>
      {/* First page */}
      {currentPage > 1 && (
        <>
          <PageButton
            label="Vorige"
            onClick={handlePrevPage}
            Icon={ChevronLeft}
            extraClasses={styles.prevPage}
            disabled={loading}
          />
          <PageButton page={1} onClick={handleGoToPage} disabled={loading} />
        </>
      )}

      {/* ... */}
      {currentPage - 2 > 1 && <span>...</span>}

      {/* Previous */}
      {currentPage - 1 > 1 && (
        <PageButton
          page={currentPage - 1}
          onClick={handleGoToPage}
          disabled={loading}
        />
      )}

      {/* Current */}
      <div data-cy="current-page" className={styles.current} disabled={loading}>
        <span className="u-visually-hidden">Pagina </span>
        {currentPage}
      </div>

      {/* Next */}
      {currentPage + 1 < totalPages && (
        <PageButton
          page={currentPage + 1}
          onClick={handleGoToPage}
          disabled={loading}
        />
      )}

      {/* ... */}
      {currentPage + 2 < totalPages && <span>...</span>}

      {/* Last page */}
      {currentPage < totalPages && (
        <>
          <PageButton
            page={totalPages}
            onClick={handleGoToPage}
            disabled={loading}
          />
          <PageButton
            label="Volgende"
            onClick={handleNextPage}
            Icon={ChevronRight}
            extraClasses={styles.nextPage}
            disabled={loading}
          />
        </>
      )}
    </div>
  );
}

PageButton.propTypes = {
  page: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  Icon: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  extraClasses: PropTypes.string,
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number,
  hasPrevPage: PropTypes.bool.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  handlePrevPage: PropTypes.func.isRequired,
  handleNextPage: PropTypes.func.isRequired,
  handleGoToPage: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default Pagination;
